module.exports = __webpack_public_path__ + "img/RodneyApplewood.b9e9eea8.jpg";